import loadable from "@loadable/component";
import { useStyletron } from "baseui";
import React, { ReactElement, ReactNode } from "react";
import { CodeBlock } from "../../markdown/CodeBlock";
import { MarkdownComponents } from "../../markdown/MarkdownComponents";
import { StyledInlineCode } from "../../markdown/Typography";

// dynamic import so that we don't need to require the ESM-only react-markdown package server side
const LazyMarkdownRenderer = loadable(() => import("../../markdown/Renderer"));

export const AssistantMarkdownRenderer = ({
  markdown,
  markdownComponents,
  fallback,
}: {
  markdown: string;
  markdownComponents?: any;
  fallback?: ReactElement;
}) => {
  return (
    <LazyMarkdownRenderer
      markdown={markdown}
      markdownComponents={{
        ...MarkdownComponents,
        code: SimpleCode,
        ...markdownComponents,
        style: (props: any) => {
          // Styles as string so that they don't get applied literally. There is a `dangerouslySetInnerHTML` used in the markdown renderer library
          return `<style>${props.children}</style>`;
        },
      }}
      fallback={fallback}
    />
  );
};

const SimpleCode = ({ children, inline, ...props }: { children: ReactNode; inline?: boolean; className?: string }) => {
  const [css, $theme] = useStyletron();

  if (inline) {
    return <StyledInlineCode {...props}>{children}</StyledInlineCode>;
  }
  return (
    <CodeBlock disallowCopy preClassName={css({ whiteSpace: "pre-wrap" })} forceLineNumbers={false} {...props}>
      {String(children)}
    </CodeBlock>
  );
};
